import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function SaturationIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M9 0H7V2H9V0Z" />
        <path d="M14.2941 3.05155L12.8803 1.63675L11.4655 3.05055L12.8793 4.46535L14.2941 3.05155Z" />
        <path d="M16 7H14V9H16V7Z" />
        <path d="M11.5353 13.0194L12.9501 14.4332L14.3639 13.0184L12.949 11.6046L11.5353 13.0194Z" />
        <path d="M9 14H7V16H9V14Z" />
        <path d="M1.56617 12.9486L2.97997 14.3633L4.39477 12.9495L2.98097 11.5347L1.56617 12.9486Z" />
        <path d="M2 7H0V9H2V7Z" />
        <path d="M4.46465 3.12033L3.04985 1.70653L1.63605 3.12133L3.05085 4.53513L4.46465 3.12033Z" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10ZM8 12C10.2091 12 12 10.2091 12 8C12 5.79086 10.2091 4 8 4C5.79086 4 4 5.79086 4 8C4 10.2091 5.79086 12 8 12Z"
        />
        <path d="M5 8H11V10H5V8Z" />
      </svg>
    </Icon>
  );
}
